"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5841],{

/***/ 7432:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export ContactForm */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _TextInput_TextInput__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7902);
/* harmony import */ var _RadioInput_RadioInput__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1427);
/* harmony import */ var _TextInputArea_TextInputArea__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3487);
/* harmony import */ var _FormSuccessDialog_FormSuccessDialog__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1987);
/* harmony import */ var _FormErrorDialog_FormErrorDialog__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(299);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(8148);
/* harmony import */ var _utils_recaptcha__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(3575);
/* harmony import */ var _Recaptcha_RecaptchaModal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4559);














var ContactForm = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), firstName = ref[0], setFirstName = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), lastName = ref1[0], setLastName = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), email = ref2[0], setEmail = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), userType = ref3[0], setUserType = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), message = ref4[0], setMessage = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), disabledField = ref5[0], setDisabledField = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showError = ref6[0], setshowError = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showSuccess = ref7[0], setshowSuccess = ref7[1];
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showCheckboxFallback = ref8[0], setShowCheckboxFallback = ref8[1];
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), pendingSubmitData = ref9[0], setPendingSubmitData = ref9[1];
    var toggleModal = function() {
        setshowError(false);
        setshowSuccess(false);
    };
    var submitForm = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(e) {
            var token, err, payload, doSubmit, response, err1;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        setDisabledField(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0,_utils_recaptcha__WEBPACK_IMPORTED_MODULE_10__/* .getRecaptchaV3Token */ .o)("contact_form")
                        ];
                    case 2:
                        token = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        err = _state.sent();
                        setshowError(true);
                        setDisabledField(false);
                        return [
                            2
                        ];
                    case 4:
                        payload = {
                            first_name: firstName,
                            last_name: lastName,
                            email_address: email,
                            who_are_you: userType,
                            message: message,
                            captcha_token: {
                                token: token,
                                version: "v3",
                                provider: 1
                            }
                        };
                        doSubmit = function() {
                            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(body) {
                                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                                    return [
                                        2,
                                        fetch("".concat(_constants__WEBPACK_IMPORTED_MODULE_11__/* .BASE_URL */ ._, "/Marketing/ContactUs"), {
                                            method: "POST",
                                            headers: {
                                                "Content-Type": "application/json"
                                            },
                                            body: JSON.stringify(body)
                                        })
                                    ];
                                });
                            });
                            return function doSubmit(body) {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        _state.label = 5;
                    case 5:
                        _state.trys.push([
                            5,
                            7,
                            ,
                            8
                        ]);
                        return [
                            4,
                            doSubmit(payload)
                        ];
                    case 6:
                        response = _state.sent();
                        return [
                            3,
                            8
                        ];
                    case 7:
                        err1 = _state.sent();
                        setshowError(true);
                        setDisabledField(false);
                        return [
                            2
                        ];
                    case 8:
                        if (response.status === 400) {
                            // If server asks for additional verification (400), ensure the generic
                            // error dialog is not shown and present the v2 checkbox fallback.
                            setshowError(false);
                            setPendingSubmitData(payload);
                            setShowCheckboxFallback(true);
                            setDisabledField(false);
                            return [
                                2
                            ];
                        }
                        if (response.status < 200 || response.status > 299) {
                            setshowError(true);
                            setDisabledField(false);
                        } else {
                            setshowSuccess(true);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function submitForm(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCheckboxVerify = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(token) {
            var res;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!pendingSubmitData) return [
                            2
                        ];
                        setShowCheckboxFallback(false);
                        setDisabledField(true);
                        return [
                            4,
                            fetch("".concat(_constants__WEBPACK_IMPORTED_MODULE_11__/* .BASE_URL */ ._, "/Marketing/ContactUs"), {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json"
                                },
                                body: JSON.stringify((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, pendingSubmitData), {
                                    captcha_token: {
                                        token: token,
                                        version: "v2",
                                        provider: 1
                                    }
                                }))
                            })
                        ];
                    case 1:
                        res = _state.sent();
                        setPendingSubmitData(null);
                        if (res.status >= 200 && res.status <= 299) {
                            setshowSuccess(true);
                        } else {
                            setshowError(true);
                        }
                        setDisabledField(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleCheckboxVerify(token) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "max-w-screen-xl px-4 py-12 mx-auto mt-16 sm:px-6 lg:px-8 bg-lightblue",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "text-center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: "pb-4 text-3xl tracking-tight md:text-4xl",
                        children: "Health Insurance with a human touch."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        className: "text-2xl font-bold uppercase text-blue",
                        children: "We’d love to hear from you. Reach out to learn more."
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                id: "recaptcha-container-invisible",
                style: {
                    display: "none"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative",
                children: [
                    showSuccess && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FormSuccessDialog_FormSuccessDialog__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        userType: userType,
                        toggleModal: toggleModal
                    }),
                    showError && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FormErrorDialog_FormErrorDialog__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        click: function(e) {
                            setshowError(false);
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                        onSubmit: submitForm,
                        className: "grid grid-cols-1 md:grid-cols-3",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "col-span-1 md:col-span-2",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "grid grid-cols-1 md:grid-cols-2",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "md:col-span-1",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TextInput_TextInput__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                required: true,
                                                labelClasses: "bg-white-light",
                                                type: "text",
                                                minLength: 2,
                                                maxLength: 20,
                                                disabled: disabledField,
                                                value: firstName,
                                                change: function(e) {
                                                    setFirstName(e.target.value);
                                                },
                                                children: "First Name"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "md:col-span-1",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TextInput_TextInput__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                required: true,
                                                labelClasses: "bg-white-light",
                                                type: "text",
                                                minLength: 2,
                                                maxLength: 20,
                                                disabled: disabledField,
                                                value: lastName,
                                                change: function(e) {
                                                    setLastName(e.target.value);
                                                },
                                                children: "Last Name"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "md:col-span-2",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TextInput_TextInput__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                required: true,
                                                labelClasses: "bg-white-light",
                                                type: "email",
                                                minLength: 2,
                                                maxLength: 60,
                                                disabled: disabledField,
                                                value: email,
                                                change: function(e) {
                                                    setEmail(e.target.value);
                                                },
                                                children: "Email"
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "col-span-1 md:col-span-1",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "py-3 my-4 border-white border-solid border-1 bg-white-light",
                                    role: "group",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                            className: "text-xl text-darkGray pl-4 font-[sans-serif]",
                                            children: "Who are you? *"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_RadioInput_RadioInput__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            required: true,
                                            name: "userType",
                                            value: "employer",
                                            selectedValue: userType,
                                            tabIndex: "0",
                                            change: function(e) {
                                                setUserType(e.target.value);
                                            },
                                            children: "Employer"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_RadioInput_RadioInput__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            required: true,
                                            name: "userType",
                                            value: "individual",
                                            selectedValue: userType,
                                            tabIndex: "0",
                                            change: function(e) {
                                                setUserType(e.target.value);
                                            },
                                            children: "Individual"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_RadioInput_RadioInput__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            required: true,
                                            name: "userType",
                                            value: "broker",
                                            selectedValue: userType,
                                            tabIndex: "0",
                                            change: function(e) {
                                                setUserType(e.target.value);
                                            },
                                            children: "Broker"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "md:col-span-3",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TextInputArea_TextInputArea__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    required: true,
                                    labelClasses: "bg-white-light",
                                    type: "text",
                                    minLength: 20,
                                    maxLength: 2000,
                                    value: message,
                                    change: function(e) {
                                        setMessage(e.target.value);
                                    },
                                    children: "Message"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mx-auto mt-8 md:col-span-3",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    type: "submit",
                                    className: "px-12 py-2 text-lg font-medium text-white bg-blue",
                                    children: "Send"
                                })
                            })
                        ]
                    }),
                    showCheckboxFallback && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        style: {
                            position: "fixed",
                            inset: 0,
                            zIndex: 9999,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                style: {
                                    background: "rgba(0,0,0,0.5)",
                                    position: "absolute",
                                    inset: 0
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                style: {
                                    zIndex: 10000,
                                    background: "#fff",
                                    padding: 20,
                                    borderRadius: 8
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        style: {
                                            marginBottom: 10
                                        },
                                        children: "Please complete the verification to continue"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Recaptcha_RecaptchaModal__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                        onVerify: function(token) {
                                            return handleCheckboxVerify(token);
                                        },
                                        onError: function() {
                                            setShowCheckboxFallback(false);
                                            setshowError(true);
                                        },
                                        onClose: function() {
                                            return setShowCheckboxFallback(false);
                                        }
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        style: {
                                            marginTop: 8,
                                            textAlign: "right"
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                            type: "button",
                                            className: "px-4 py-2 text-sm",
                                            onClick: function() {
                                                setShowCheckboxFallback(false);
                                            },
                                            children: "Cancel"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContactForm);


/***/ }),

/***/ 9534:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ })

}]);